import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { AuthLink as Link } from '../auth/AuthContext';
import api from '../api';
import AuthCard from '../components/AuthCard';
import RegistrationAgreements from '../components/RegistrationAgreements';
import SocialLoginButtons from '../components/SocialLoginButtons';

export default function RegisterPage() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [visible, setVisible] = useState(false);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [agreements, setAgreements] = useState(null);
    const register = async event => {
        event.preventDefault();
        if (loading || !agreements) return;
        setLoading(true); setError(null);
        try {
            const { data } = await api.post('/api/auth/register', { email, password, agreements });
            window.location.assign(data?.targetUrl || '/dashboard/profile');
        } catch (failure) {
            const message = failure.response?.data?.detail || failure.response?.data?.message || failure.response?.data;
            setError(typeof message === 'string' && message.includes('Email already exists')
                ? 'Пользователь с таким email уже существует' : typeof message === 'string' ? message : 'Не удалось создать аккаунт. Попробуйте снова.');
            setLoading(false);
        }
    };
    return <AuthCard title="Регистрация" backTo="/login" variant="registration">
        <form onSubmit={register} className="flex flex-col gap-4">
            <div className="auth-registration-fields">
            <input type="email" aria-label="Email" placeholder="Email" autoComplete="email" value={email} onChange={event => setEmail(event.target.value)} required disabled={loading} />
            <div className="auth-password">
                <input type={visible ? 'text' : 'password'} aria-label="Пароль" placeholder="Пароль" autoComplete="new-password" value={password} onChange={event => setPassword(event.target.value)} required minLength={6} disabled={loading} />
                <button type="button" className="auth-password-toggle" aria-label={visible ? 'Скрыть пароль' : 'Показать пароль'} aria-pressed={visible} onClick={() => setVisible(value => !value)}>{visible ? <EyeOff size={20} /> : <Eye size={20} />}</button>
            </div>
            <RegistrationAgreements onChange={setAgreements} disabled={loading} />
            {error && <p role="alert" className="auth-error">{error}</p>}
            </div>
            <button type="submit" className="auth-primary" disabled={loading || !agreements}>{loading ? 'Создаём аккаунт…' : 'Зарегистрироваться'}</button>
        </form>
        <SocialLoginButtons registration consent={agreements} busy={loading} onError={setError} />
        <div className="auth-login-links"><p>Уже есть аккаунт? <Link to="/login">Войти</Link></p></div>
    </AuthCard>;
}
